

export class TestDataManagement {

  static datatenantPrexix = "test.tenantlist";
  static dataUserPrexix = "test.userlist";
  static tenantData = [];
  static userData = {
    product: [],
    system: [],
    user: []
  };

  static listTenantData(){
    TestDataManagement.tenantData = TestDataManagement.loadTenant();
    return TestDataManagement.tenantData;
  };

  static listUserData(type){
    TestDataManagement.userData[type] = TestDataManagement.loadUser(type)
    return TestDataManagement.userData[type];
  }


  static putTenantData(row){
    if(row.type == 'create'){
      const newList = [...TestDataManagement.tenantData,row];
      TestDataManagement.saveTenant(newList);
      TestDataManagement.tenantData = newList;
    }else if(row.type == 'update'){
      console.log("putTenant#update",row);
      const newList = TestDataManagement.tenantData.map((item) => {
        return row.id == item.id ? row : item
      })
      console.log("putTenant#update",newList);
      TestDataManagement.saveTenant(newList);
      TestDataManagement.tenantData = newList;
    } else{
      //delete
      const newList = TestDataManagement.tenantData.filter((item) => {
        return row.id == item.id ? false : true
      })
      TestDataManagement.saveTenant(newList);
      TestDataManagement.tenantData = newList;
    }

  };

  static putUserData(type,row){
    if(row.type == 'create'){
      const newList = [...TestDataManagement.userData[type],row];
      TestDataManagement.saveUsers(type,newList);
      TestDataManagement.userData[type] = newList;
    }else if(row.type == 'update'){
      console.log("putTenant#update",row);
      const newList = TestDataManagement.userData[type].map((item) => {
        return row.id == item.id ? row : item
      })
      console.log("putTenant#update",newList);
      TestDataManagement.saveUsers(type,newList);
      TestDataManagement.userData[type] = newList;
    } else{
      //delete
      const newList = TestDataManagement.userData[type].filter((item) => {
        return row.id == item.id ? false : true
      })
      TestDataManagement.saveUsers(type,newList);
      TestDataManagement.userData[type] = newList;
    }

  };


  static saveTenant(replace){
    sessionStorage.setItem(TestDataManagement.datatenantPrexix,JSON.stringify(replace));
  };


  static saveUsers(type,replcae){
    sessionStorage.setItem(TestDataManagement.dataUserPrexix + "." + type,JSON.stringify(replcae));
  }

  static loadTenant() {

      let data =  JSON.parse(sessionStorage.getItem(TestDataManagement.datatenantPrexix));
      if(!data || data.length == 0){
        data = testTenantData;
      }

      return data;
  }

  static loadUser(type) {

    let loadData =  sessionStorage.getItem(TestDataManagement.dataUserPrexix + "." + type);
    if(!loadData || loadData.length == 0){
      return TestUserData;
    }else{
      return JSON.parse(loadData);
    }

  }



}

const testTenantData = [
  {id: "sutrix",name: "sutrix",entrytime: "1674151220000",tenant: "sutrix"},
  {id: "AdminTenant",name: "Adminテナント",entrytime: "1674648620000",tenant: "AdminTenant"},
  {id: "testGetUserstemp",name: "テストユーザテナント",entrytime: "1674910230000",tenant: "testGetUserstemp"},
];

const TestUserData = [
  {
    id: '1',
    uid: 'abcdef',
    familyname: 'ファミリー1',
    lastname: '名',
    email: 'abcdef@example.com',
    tenantid: '1',
    entrytime: '1674727200000',
    isAvailable: true,
  },
  {
    id: '2',
    uid: 'defghi',
    familyname: 'ファミリー2',
    lastname: '名2',
    email: 'defghi@example.com',
    tenantid: '2',
    entrytime: '1674727200000',
    isAvailable: true,
  },
  {
    id: '3',
    uid: 'test3',
    familyname: 'ファミリー3',
    lastname: '名3',
    email: 'test3@example.com',
    tenantid: '3',
    entrytime: '1674640800000',
    isAvailable: true,
  },
  {
    id: '4',
    uid: 'test3',
    familyname: 'ファミリー4',
    lastname: '名4',
    email: 'test4@example.com',
    tenantid: '1',
    entrytime: '1674640800000',
    isAvailable: true,
  },
  {
    id: '5',
    uid: 'test5',
    familyname: 'ファミリー5',
    lastname: '名5',
    email: 'test5@example.com',
    tenantid: '1',
    entrytime: '1674640800000',
    isAvailable: false,
  },
  {
    id: '6',
    uid: 'test6',
    familyname: 'ファミリー6',
    lastname: '名6',
    email: 'test6@example.com',
    tenantid: '1',
    entrytime: '1674640800000',
    isAvailable: true,
  },
]